import React from "react";

export const MdNavigate = () => (<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 512 512"><path d="M256 64L96 433.062 110.938 448 256 384l145.062 64L416 433.062z"/></svg>) as JSX.Element;
